import "./Navbar.css";
import logo from "../../assets/logo/inioli_logo.jpeg";
import { Link } from "react-router-dom";


const Logo = () => {

    return (
        <>
            <Link to="/"><img src={logo} alt="Logo" className="relative" /> </Link>
        </>
    );
};

export default Logo;